import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

export default function DrugDscTooltip(props: any) {
  const { row, needPharmacy, showInactivationDetails } = props;
  return (
    <Grid container rowSpacing={1} columnSpacing={2}>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Drug Name:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {!row.drugName ? "Not Available" : row.drugName}
        </Typography>
      </Grid>
      {row?.drugNameInDB && (
        <>
          <Grid item xs={12} md={4}>
            <Typography component={"div"} variant={"body2"} fontWeight={600}>
              Drug Name In DB:
            </Typography>
          </Grid>
          <Grid item xs={12} md={8}>
            <Typography component={"div"} variant={"body2"}>
              {row?.drugNameInDB}
            </Typography>
          </Grid>
        </>
      )}
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Drug Description:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {!row.description ? "Not Available" : row.description}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Drug Type:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {!row.drugType ? "Not Available" : row.drugType}
        </Typography>
      </Grid>
      {row?.oldSig && (
        <>
          <Grid item xs={12} md={4}>
            <Typography component={"div"} variant={"body2"} fontWeight={600}>
              Old Sig:
            </Typography>
          </Grid>
          <Grid item xs={12} md={8}>
            <Typography component={"div"} variant={"body2"}>
              {row?.oldSig}
            </Typography>
          </Grid>
        </>
      )}
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Sig:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {!row.sig ? "Not Available" : row.sig}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Dose:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {!row.strength ? "Not Available" : row.strength}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Dose Unit:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {!row.strengthUnit ? "Not Available" : row.strengthUnit}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Dosage Form:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {!row.dosageForm ? "Not Available" : row.dosageForm}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Route:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {!row.route ? "Not Available" : row.route}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Quantity Qualifier:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {!row.quantityQualifier ? "Not Available" : row.quantityQualifier}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Quantity:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {!row.quantity ? "Not Available" : row.quantity}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Refills:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {!row.refills ? "Not Available" : row.refills}
        </Typography>
      </Grid>
      {needPharmacy && (
        <>
          <Grid item xs={12} md={4}>
            <Typography component={"div"} variant={"body2"} fontWeight={600}>
              Pharmacy Name:
            </Typography>
          </Grid>
          <Grid item xs={12} md={8}>
            <Typography component={"div"} variant={"body2"}>
              {!row.pharmacyName ? "Not Available" : row.pharmacyName}
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography component={"div"} variant={"body2"} fontWeight={600}>
              Pharmacy Address:
            </Typography>
          </Grid>
          <Grid item xs={12} md={8}>
            <Typography component={"div"} variant={"body2"}>
              {!row.pharmacyAddress ? "Not Available" : row.pharmacyAddress}
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography component={"div"} variant={"body2"} fontWeight={600}>
              Phone:
            </Typography>
          </Grid>
          <Grid item xs={12} md={8}>
            <Typography component={"div"} variant={"body2"}>
              {!row.pharmacyPhone ? "Not Available" : row.pharmacyPhone}
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography component={"div"} variant={"body2"} fontWeight={600}>
              Fax:
            </Typography>
          </Grid>
          <Grid item xs={12} md={8}>
            <Typography component={"div"} variant={"body2"}>
              {!row.pharmacyFaxNumber ? "Not Available" : row.pharmacyFaxNumber}{" "}
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography component={"div"} variant={"body2"} fontWeight={600}>
              Note to Pharmacist:
            </Typography>
          </Grid>
          <Grid item xs={12} md={8}>
            <Typography component={"div"} variant={"body2"}>
              {!row.instructions ? "Not Available" : row.instructions}
            </Typography>
          </Grid>
        </>
      )}
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Notes:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {!row.doctorNote ? "Not Available" : row.doctorNote}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          DDID:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {!row.dispensibleDrugId ? "Not Available" : row.dispensibleDrugId}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Rx Norm:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {!row.rxNorm ? "Not Available" : row.rxNorm}
        </Typography>
      </Grid>
      {showInactivationDetails && (
        <>
          <Grid item xs={12} md={4}>
            <Typography component={"div"} variant={"body2"} fontWeight={600}>
              Inactivation Reason:
            </Typography>
          </Grid>
          <Grid item xs={12} md={8}>
            <Typography component={"div"} variant={"body2"}>
              {!row.inactivationReason
                ? "Not Available"
                : row.inactivationReason}
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography component={"div"} variant={"body2"} fontWeight={600}>
              Inactivation Date:
            </Typography>
          </Grid>
          <Grid item xs={12} md={8}>
            <Typography component={"div"} variant={"body2"}>
              {!row.inactivationDate ? "Not Available" : row.inactivationDate}
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography component={"div"} variant={"body2"} fontWeight={600}>
              Inactivated By:
            </Typography>
          </Grid>
          <Grid item xs={12} md={8}>
            <Typography component={"div"} variant={"body2"}>
              {!row.inactivatedBy ? "Not Available" : row.inactivatedBy}
            </Typography>
          </Grid>
        </>
      )}
      {row?.nurseName && (
        <>
          <Grid item xs={12} md={4}>
            <Typography component={"div"} variant={"body2"} fontWeight={600}>
              On behalf user:
            </Typography>
          </Grid>
          <Grid item xs={12} md={8}>
            <Typography component={"div"} variant={"body2"}>
              {row?.nurseName}
            </Typography>
          </Grid>
        </>
      )}
      {row?.cancelReqDate && (
        <>
          <Grid item xs={12} md={4}>
            <Typography component={"div"} variant={"body2"} fontWeight={600}>
              Cancellation Date:
            </Typography>
          </Grid>
          <Grid item xs={12} md={8}>
            <Typography component={"div"} variant={"body2"}>
              {row?.cancelReqDate}
            </Typography>
          </Grid>
        </>
      )}
      {row?.cancelledBy && (
        <>
          <Grid item xs={12} md={4}>
            <Typography component={"div"} variant={"body2"} fontWeight={600}>
              Cancelled By:
            </Typography>
          </Grid>
          <Grid item xs={12} md={8}>
            <Typography component={"div"} variant={"body2"}>
              {row?.cancelledBy}
            </Typography>
          </Grid>
        </>
      )}
    </Grid>
  );
}
